/* eslint-disable import/no-duplicates */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import ProfileDropdown from '@/components/ProfileDropdown';
import CustomersTables from './components/CustomerTable';
import {
  ComponentsView,
  ContainerHeaderView,
  ContainerView,
  CustomersView,
  HeaderView,
  PageTitleView,
  SearchView
} from './customers.styles';
import { ReactComponent as BackIcon } from '@/assets/icons/back.icon.svg';
import { ReactComponent as PlusIcon } from '@/assets/icons/plus.icon.svg';
import { ReactComponent as MenuIcon } from '@/assets/icons/menu.icon.svg';
import { ReactComponent as SearchIcon } from '@/assets/icons/search.icon.svg';
import { fetchCustomers } from '@/services/customerApi';
import FetchLoader from '@/components/FetchLoader';
import { PaginationView } from './customers.styles';
import Pagination from '@/components/Pagination';
import MobileSidebar from '@/components/MobileSidebar';
import withAuthentication from '@/hooks/withAuthentication';
import ComplianceWarnModal from '@/components/ComplianceWarnModal';
import { fetchCompany, fetchUser } from '@/services/userApi';
import useDebounce from '@/hooks/useDebounce';
import SortingComponent from '@/components/SortingComponent';
import FilterSort from '@/components/FilterSort';
import secureLocalStorage from 'react-secure-storage';
import { truncate } from '@/utils/helpers';
import TableRowsSelect from '@/components/TableRowSelect';

function Customers() {
  const navigate = useNavigate();
  const companyId = secureLocalStorage.getItem('company');
  const [openNav, setOpenNav] = useState(false);
  const [showComplianceWarning, setShowComplianceWarning] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const limit = searchParams.get('limit');
  const currentPage = searchParams.get('page');
  const [search, setSearch] = useState('');
  const [sortOrder, setSortOrder] = useState('none');
  const [filter, setFilter] = useState('none');
  const debouncedsearch = useDebounce(search, 500);

  const handleFilterApply = useCallback(({ filter }) => {
    setFilter(filter);
  }, []);

  const user = useQuery({
    queryKey: ['user'],
    queryFn: fetchUser
  });

  const company = useQuery({
    queryKey: ['company', companyId],
    queryFn: fetchCompany
  });

  const customers = useQuery({
    queryKey: [
      'customers',
      {
        page: currentPage || 1,
        pageLimit: limit || 10,
        search: debouncedsearch?.trim(),
        sortBy: sortOrder,
        fetch: filter
      }
    ],
    queryFn: fetchCustomers,
    enabled: user?.data?.data?.complianceVerified || false
  });

  const handleRowsPerPageChange = (value) => {
    setSearchParams(`&page=1&limit=${value}`);
  };

  const onPageChange = (page) => {
    setSearchParams(`page=${page}&limit=${limit || 10}`);
  };

  useEffect(() => {
    if (!user?.isLoading && user?.data?.data) {
      if (user?.data?.data?.complianceVerified) {
        setShowComplianceWarning(false);
      }
      if (!user?.data?.data?.complianceVerified) {
        setShowComplianceWarning(true);
      }
    } else {
      setShowComplianceWarning(false);
    }
  }, [user?.data?.data]);

  return (
    <>
      <MobileSidebar openNav={openNav} setOpenNav={setOpenNav} />
      <CustomersView>
        <HeaderView>
          <div className="title-view">
            <button type="button" className="menu" onClick={() => setOpenNav(true)}>
              <MenuIcon />
            </button>
            <h3>{truncate(company?.data?.data?.name || '', 40, true)}</h3>
          </div>
          <ProfileDropdown />
        </HeaderView>
        <ContainerView>
          <PageTitleView>
            <button type="button">
              <BackIcon />
            </button>
            <h3>Get Paid</h3>
          </PageTitleView>

          <ContainerHeaderView>
            <div className="row1">
              <h3>Customers</h3>
              {user?.data?.data?.complianceVerified && (
                <button
                  type="button"
                  className="add"
                  onClick={() => navigate('/get-paid/customers/create')}>
                  <PlusIcon /> New Customer
                </button>
              )}
            </div>

            <div className="row2">
              <SearchView>
                <input
                  type="search"
                  placeholder="Search customers"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <SearchIcon className="search-icon" />
              </SearchView>
              <SortingComponent sortOrder={sortOrder} onSortChange={setSortOrder} />
              <FilterSort onApply={handleFilterApply} />
            </div>
          </ContainerHeaderView>

          <ComponentsView>
            {customers?.isLoading ? (
              <FetchLoader />
            ) : (
              <CustomersTables customers={customers?.data?.data} />
            )}
          </ComponentsView>

          <PaginationView>
            <Pagination
              itemsPerPage={limit || 10}
              totalItems={customers?.data?.data?.meta?.total}
              currentPage={customers?.data?.data?.meta?.page}
              onPageChange={onPageChange}
            />

            <TableRowsSelect onChange={handleRowsPerPageChange} />
          </PaginationView>
        </ContainerView>
      </CustomersView>

      <ComplianceWarnModal
        showModal={showComplianceWarning}
        setShowModal={setShowComplianceWarning}
      />
    </>
  );
}

export default withAuthentication(Customers);
